import React from 'react';

import { humanizeSlug } from '../../../utils/formatters';
import {
  formatWizardLanesLabel,
  WizardSelections,
} from '../wizardLogic';

export interface WizardStepLaneProps {
  readonly lanes: readonly string[];
  readonly selections: WizardSelections;
  readonly parameterLabel: string;
  readonly surveyYearLabel: string;
  readonly onSelectLane: (lane: string) => void;
}

function WizardStepLane({
  lanes,
  selections,
  parameterLabel,
  surveyYearLabel,
  onSelectLane,
}: WizardStepLaneProps): JSX.Element {
  return (
    <div className="sdm-add-layer-wizard__panel">
      <h4 className="sdm-add-layer-wizard__panel-title">Choose lane</h4>
      <p className="sdm-add-layer-wizard__hint">
        Choose a lane to continue to visualisation.
      </p>

      <div className="sdm-add-layer-wizard__card-grid sdm-add-layer-wizard__card-grid--lanes">
        {lanes.length === 0 ? (
          <p className="sdm-add-layer-wizard__hint" role="status">
            No lanes are configured for the selected survey year.
          </p>
        ) : null}
        {lanes.map((lane) => {
          const isSelected = selections.lanes.includes(lane);

          return (
            <button
              key={lane}
              type="button"
              className={`sdm-add-layer-wizard__card sdm-add-layer-wizard__card--compact${
                isSelected ? ' sdm-add-layer-wizard__card--selected' : ''
              }`}
              onClick={() => onSelectLane(lane)}
              aria-pressed={isSelected}
            >
              <strong>{humanizeSlug(lane)}</strong>
            </button>
          );
        })}
      </div>

      <div className="sdm-add-layer-wizard__summary">
        <h5>Configuration summary</h5>
        <dl>
          <div>
            <dt>Survey type</dt>
            <dd>{humanizeSlug(selections.surveyType ?? '')}</dd>
          </div>
          <div>
            <dt>Parameter group</dt>
            <dd>{selections.defectGroup}</dd>
          </div>
          <div>
            <dt>Parameter</dt>
            <dd>{parameterLabel}</dd>
          </div>
          <div>
            <dt>Year</dt>
            <dd>{surveyYearLabel}</dd>
          </div>
          <div>
            <dt>Lane</dt>
            <dd>{formatWizardLanesLabel(selections.lanes, lanes) || 'Not selected'}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}

export default WizardStepLane;
